const DOCUMENT_STYLES = `body{font-family:-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;margin:24px;color:#0f172a;font-size:14px;line-height:1.5;}
.print-content{display:block;color:inherit;}
.print-pre{white-space:pre-wrap;word-break:break-word;font:inherit;}
table{border-collapse:collapse;width:100%;margin:16px 0;font-size:14px;}
th,td{border:1px solid #d4d8e3;padding:6px 8px;vertical-align:top;}
th{background:#f6f8fb;font-weight:600;}
code{font-family:monospace;padding:0 4px;background:#f1f5f9;border-radius:4px;}
pre code{padding:0;background:none;}
blockquote{border-left:3px solid #94a3b8;margin:12px 0;padding:4px 16px;color:#475569;}
ul,ol{padding-left:20px;}
hr{border:0;border-top:1px solid #e2e8f0;margin:24px 0;}`;

export const escapeHtml = (text: string): string =>
  text.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

export const stripScripts = (html: string): string => html.replace(/<script[\s\S]*?>[\s\S]*?<\/script>/gi, '');

export const wrapHtmlContent = (html: string): string => `<div class="print-content">${html}</div>`;

export const wrapPlainTextContent = (plainText: string): string =>
  `<pre class="print-pre">${escapeHtml(plainText)}</pre>`;

export const buildDocumentTemplate = (title: string, body: string, styles: string = DOCUMENT_STYLES) =>
  `<!doctype html><html><head><meta charset="utf-8"/><title>${title}</title><style>${styles}</style></head><body>${body}</body></html>`;
